import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const plansDirectoryRoute: InvariantJiraRoute = {
	name: 'plans-directory',
	path: '/jira/plans',
};
